import { render, staticRenderFns } from "./ReturnSalesList.vue?vue&type=template&id=57a2555a&scoped=true"
import script from "./ReturnSalesList.vue?vue&type=script&lang=js"
export * from "./ReturnSalesList.vue?vue&type=script&lang=js"
import style0 from "./ReturnSalesList.vue?vue&type=style&index=0&id=57a2555a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a2555a",
  null
  
)

export default component.exports